/**
 * SPEED wave 1, fix 7 — ONE key and ONE freshness policy for the teacher dashboard read.
 *
 * WHY THIS MODULE EXISTS, and it is a sharper point than fix 9's. The teacher home and the two
 * first-run hooks were ALREADY sharing the key `["teacher-dashboard", "semester"]` on purpose —
 * their comments say so, and whoever aligned them was right. But they disagreed about FRESHNESS:
 *
 *     TeacherWorkspacePage   staleTime: 30_000
 *     useFirstRunState       (none -> 0)
 *     useSetupGate           (none -> 0)
 *
 * Two observers of one cache, one of which considers the data stale the instant it arrives. The
 * second to mount refetches what the first has just fetched, so the teacher home made TWO calls for
 * one dashboard on every load — including the load right after login, which is where it was noticed.
 *
 * SHARING A KEY IS NOT ENOUGH; THE POLICY HAS TO BE SHARED TOO. That is the half of fix 9's lesson
 * that fix 9 did not have to learn, because there the second consumer had its own key and the
 * duplicate was obvious. Here the cache was shared and the duplicate was invisible in the key.
 *
 * Measured with the same script on both sides (`dashboardRequests.test.js`): **2 requests -> 1.**
 *
 * SPEED retired the wall-time row for this class of fix, correctly: the duplicate calls ran in
 * PARALLEL, so the win is server load and a teacher's data allowance, not page latency. Worth
 * saying plainly rather than claiming a speed-up nobody would feel.
 */

/**
 * The ONE key. "semester" is the teacher workspace's default period and the value the first-run
 * hooks were already written against; it is a constant here so a fourth consumer cannot invent a
 * variant by typing the array again.
 */
export const TEACHER_DASHBOARD_KEY = ["teacher-dashboard", "semester"];

/**
 * How long a fetched dashboard stays fresh for EVERY observer.
 *
 * 30 seconds, which is the teacher home's existing window — the page that actually displays the
 * numbers, and therefore the one whose opinion about staleness should win. The first-run hooks only
 * ask whether setup is finished, a question whose answer does not change second to second.
 * An invalidation still refetches immediately, so anything that genuinely changes the dashboard
 * still shows up at once.
 */
export const TEACHER_DASHBOARD_STALE_MS = 30_000;

export default TEACHER_DASHBOARD_KEY;
